// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__Ks-2Z","sendOtp":"AuthorizeToLogin_sendOtp__UUBPe"};